export const AddModelTabs = ({
  activeTab,
  setActiveTab,
}: {
  activeTab: string;
  setActiveTab: (tab: string) => void;
}) => {
  const tabs = [
    {
      label: 'Basic Info',
      value: 'basic',
    },
    {
      label: 'System Prompt',
      value: 'prompt',
    },
    {
      label: 'Suggested Prompts',
      value: 'suggested',
    },
    {
      label: 'Tools & Servers',
      value: 'tools',
    },
    {
      label: 'Files',
      value: 'files',
    },
  ];
  return (
    <div className="flex border-b" style={{ borderColor: "hsl(var(--muted-foreground))" }}>
      {tabs.map((tab) => (
        <button
          key={tab.value}
          onClick={() => setActiveTab(tab.value)}
          className={`px-6 py-3 text-sm font-medium border-b-2 transition-colors ${activeTab === tab.value ? '' : 'border-transparent'
            }`}
          style={{
            color: activeTab === tab.value ? "hsl(var(--primary))" : "hsl(var(--foreground))",
            borderColor: activeTab === tab.value ? "hsl(var(--primary))" : 'transparent',
          }}
          onMouseEnter={(e) => {
            if (activeTab !== tab.value) {
              e.currentTarget.style.color = "hsl(var(--primary))";
            }
          }}
          onMouseLeave={(e) => {
            if (activeTab !== tab.value) {
              e.currentTarget.style.color = "hsl(var(--foreground))";
            }
          }}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};
